import type { ReleaseListRow } from 'fym-shared/src/music24/releases';
import { CatalogItem } from '../../../../../redux/api/fymAPI.types';
import { isDraftItem } from './releaseDraft';

/** One release of the list: the catalog row (title, cover, date) and the server row (counts, next step). */
export interface ReleaseEntry {
  item: CatalogItem;
  row: ReleaseListRow;
}

export interface ReleaseEntryGroups {
  /** Typed songs with only a title (owner answer 1, 2026-10-09): shown first, never hidden in Quiet. */
  drafts: ReleaseEntry[];
  upcoming: ReleaseEntry[];
  active: ReleaseEntry[];
  quiet: ReleaseEntry[];
}

function matches(item: CatalogItem, query: string): boolean {
  if (query === '') {
    return true;
  }
  const needle = query.toLocaleLowerCase();
  return item.title.toLocaleLowerCase().includes(needle) || item.artistName.toLocaleLowerCase().includes(needle);
}

/**
 * The three groups of the list, in the server order (`GET /releases`: Upcoming soonest first,
 * Active newest activity first, Quiet newest release first). A server row with no catalog row
 * (the catalog read is older) is left out. `query` keeps the songs whose title or artist holds it.
 * A draft (`isDraftItem`) goes to Drafts, whatever its server group: a new draft has no activity, and
 * Quiet would hide it.
 */
export function groupReleaseEntries(items: CatalogItem[], rows: ReleaseListRow[], query: string): ReleaseEntryGroups {
  const byUuid = new Map(items.map((item) => [item.uuid, item]));
  const trimmed = query.trim();
  const groups: ReleaseEntryGroups = { drafts: [], upcoming: [], active: [], quiet: [] };
  for (const row of rows) {
    const item = byUuid.get(row.catalogItemUuid);
    if (item !== undefined && matches(item, trimmed)) {
      groups[isDraftItem(item) ? 'drafts' : row.group].push({ item, row });
    }
  }
  return groups;
}
